
<template>
    <div id="schedule" v-if="sData">
        <vue-headful :title="$t('schedule')" />
        <!-- Фильтры -->
        <vs-card class="mb-8">
            <div slot="header" class="flex justify-between items-center flex-wrap">
                <h3 class="mt-2 lg:ml-2 mb-1 lg:mb-0 text-lg lg:text-xl">{{ $t("options-filter") }}</h3>
                <vs-button
                    :class="wMobile ? 'mt-2' : ''"
                    icon-pack="feather"
                    :icon="
                        filterActive ? 'icon-chevron-up' : 'icon-chevron-down'
                    "
                    @click="filterActive = !filterActive"
                    >{{
                        filterActive ? $t("hide-filters") : $t("show-filters")
                    }}</vs-button
                >
            </div>
            <div v-show="filterActive">
                <div class="vx-row -mt-4 custom-select-filters">
                    <!-- Рендер селектов по струтуре -->
                    <MySelect
                        class="vx-col md:w-1/4 sm:w-1/2 w-full"
                        v-for="select in listSelects"
                        :key="select.nameI18nAndQueryParam"
                        :data="select"
                    />
                </div>
                <!-- Выбор даты -->
                <div class="vx-row">
                    <div class="vx-col md:w-1/4 sm:w-1/2 w-full lg:ml-2">
                        <flat-pickr
                            :config="configDateTimePicker"
                            :class="wMobile ? 'w-full' : ''"
                            style="width: 95%"
                            :placeholder="$t('date')"
                            v-model="selectDate"
                        />
                    </div>
                    <!-- Применить фильтры -->
                    <div
                        class="vx-col md:w-1/4 sm:w-1/2"
                        :class="[wMobile ? 'mt-2' : '']"
                    >
                        <vs-button class="w-full lg:w-auto" @click="applyFilters">{{
                            $t("apply")
                        }}</vs-button>
                    </div>
                    <!-- Очистить фильтры -->
                    <div
                        :class="[wMobile ? 'mt-2' : '']"
                        class="vx-col md:w-1/4 sm:w-1/2"
                    >
                        <vs-button class="w-full lg:w-auto" @click="clearFilters">{{
                            $t("clear")
                        }}</vs-button>
                    </div>
                </div>
            </div>
        </vs-card>

        <div
            class="vx-row flex"
            :class="wMobile ? 'justify-center' : 'justify-between'"
        >
            <div class="vx-col">
                <!--Предыдущая неделя  -->
                <vs-button
                    icon-pack="feather"
                    icon="icon-arrow-left"
                    class="arrow_btn"
                    @click="paginationWeek('prev')"
                    type="border"
                    >{{ !wMobile ? $t("prev-week") : "" }}</vs-button
                >
            </div>
            <div v-if="wMobile" class="flex">
                <vs-button
                    type="border"
                    icon="icon-layout"
                    icon-pack="feather"
                    :active="true"
                    @click="selectTypeView('table')"
                >
                </vs-button>
                <vs-button
                    class="ml-2"
                    type="border"
                    icon="icon-list"
                    icon-pack="feather"
                    @click="selectTypeView('list')"
                >
                </vs-button>
            </div>
            <!-- Следующая неделя -->
            <div class="vx-col" v-if="wMobile">
                <vs-button
                    icon-pack="feather"
                    icon="icon-arrow-right"
                    class="arrow_btn"
                    icon-after
                    @click="paginationWeek('next')"
                    type="border"
                    >{{ !wMobile ? $t("next-week") : "" }}</vs-button
                >
            </div>
            <div class="vx-col mt-2 justify-center">
                <!-- Выбранный период даты -->

                <!-- Кнопки выбора типа расписания -->
                <div v-if="!wMobile" class="flex ml-10">
                    <vs-button
                        type="border"
                        icon="icon-layout"
                        icon-pack="feather"
                        :active="true"
                        @click="selectTypeView('table')"
                    >
                    </vs-button>
                    <vs-button
                        class="ml-2"
                        type="border"
                        icon="icon-list"
                        icon-pack="feather"
                        @click="selectTypeView('list')"
                    >
                    </vs-button>
                </div>
                <span class="headline mt-2">
                    {{ sData.schedule_date }}
                </span>
            </div>
            <!-- Следующая неделя -->
            <div class="vx-col" v-if="!wMobile">
                <vs-button
                    icon-pack="feather"
                    icon="icon-arrow-right"
                    icon-after
                    @click="paginationWeek('next')"
                    type="border"
                    >{{ !wMobile ? $t("next-week") : "" }}</vs-button
                >
            </div>
        </div>
        <!-- Таблицы -->
        <schedule
            :typeView="typeView"
            @getSchedule="getSchedule"
            :data="sData"
        />
    </div>
</template>

<script>
import vSelect from "vue-select";
import MySelect from "./Multiselect";
import Schedule from "./Schedule";

import flatPickr from "vue-flatpickr-component";
import { Russian } from "flatpickr/dist/l10n/ru";
import { Kazakh } from "flatpickr/dist/l10n/kz";

export default {
    components: {
        vSelect,
        Schedule,
        MySelect,
        flatPickr,
    },
    data() {
        return {
            typeView: "table",
            sData: null,
            filterActive: false,
            listSelects: [
                {
                    nameI18nAndQueryParam: "group",
                    endpoint: "schedules/groups/",
                },
                {
                    nameI18nAndQueryParam: "discipline",
                    endpoint: "schedules/disciplines/",
                },
                {
                    nameI18nAndQueryParam: "teacher",
                    endpoint: "schedules/teachers/",
                },
                {
                    nameI18nAndQueryParam: "class_room",
                    endpoint: "schedules/class_rooms/",
                },
            ],
            selectDate: new Date(),
            firstDate: "",
            lastDate: "",
            configDateTimePicker: {
                enableTime: false,
                dateFormat: "d.m.Y",
                // locale: this.$i18n.locale === "kk" ? "kz" : this.$i18n.locale,
            },
        };
    },
    watch: {
        "$route.query"(newVAl) {
            // Проверка заполнено ли достаточно селектов, чтобы получить список заявок от студентов
            //this.checkSelectsDataForRequest();
        },

        selectDate() {
            this.filterDate();
        },
    },
    computed: {
        wMobile() {
            return this.$store.state.windowWidth < 600 ? true : false;
        },
    },
    created() {
        this.getSchedule();
    },
    methods: {
        // Получения расписания
        async getSchedule() {
            this.$vs.loading();
            // Запрос
            let params = this.$route.query;
            params['my'] = 1;

            const response = (
                await this.$http.get("schedules", {
                    params: params
                })
            ).data;

            let returnObjectForSchedule = {};

            // Ставлю даты для рендера
            returnObjectForSchedule[
                "schedule_date"
            ] = `${ response.results.first_date } - ${ response.results.last_date }`;
            this.firstDate = response.results.first_date;
            this.lastDate = response.results.last_date;
            this.selectDate = response.results.first_date;
            // Ставлю дни для рендера
            returnObjectForSchedule[
                "schedule_days"
            ] = response.results.days.map((day) => {
                return { date: day.date, week_day: day.week_day };
            });

            // Ставлю саму таблицу расписания
            const timeLessons = response.results.days[0].windows.map((time) => {
                return { start: time.start, end: time.end,name:time.name };
            });

            let schedule = { table: null, list: null };

            schedule["table"] =
                // Прохожусь по времени пар
                timeLessons.map((time) => {
                    // Паттерн пары
                    const periodTime = {
                        windows: [],
                        start: time.start,
                        end: time.end,
                        name: time.name,
                    };
                    // Прохожусь по дням
                    response.results.days.forEach((day) => {
                        // Прохожусь по урокам дня
                        day.windows.forEach((window) => {
                            // Сравниваю начало урока и текущим из цикла временем и пушу
                            if (window.start === time.start)
                                periodTime.windows.push(window);
                        });
                    });
                    return periodTime;
                });
            // Запись данных для типа list
            schedule["list"] = response.results.days;

            returnObjectForSchedule["schedule"] = schedule;

            this.sData = { ...returnObjectForSchedule };

            this.$vs.loading.close();
        },
        applyFilters() {
            let queries = { ...this.$route.query };
            queries['by_exact_date'] = 1;
            // Редактирую текущий квери
            delete queries["prev_week"];
            delete queries["next_week"];
            this.$router.replace({ name: this.$route.name, query: queries });
            this.checkSelectsDataForRequest();
        },
        // Пагинация по неделям
        paginationWeek(value) {
            // Клонирую квери от урл
            let queries = { ...this.$route.query };
            // Редактирую текущий квери
            delete queries['by_exact_date']
            delete queries["prev_week"];
            delete queries["next_week"];
            queries["date"] = this.selectDate;
            if (value === "prev") {
                queries["prev_week"] = 1;
            } else queries["next_week"] = 1;
            // Записываю объект в квери урл
            this.$router.replace({ name: this.$route.name, query: queries });
            this.checkSelectsDataForRequest();
        },
        // Фильтрация по дате
        filterDate() {
            // Клонирую квери от урл
            let queries = { ...this.$route.query };
            // Редактирую текущий квери
            // queries["date"] = this.$moment(this.selectDate).format(
            //     "DD.MM.YYYY"
            // );
            queries["date"] = this.selectDate;
            // Записываю объект в квери урл
            this.$router.replace({ name: this.$route.name, query: queries });
        },
        // Отчистка фильтров
        clearFilters() {
            this.$router.replace({ name: this.$route.name, query: {} });
            this.selectDate = this.$moment().format("DD.MM.YYYY");
        },
        // Выбор типа расписания
        selectTypeView(value) {
            if (value === "table") {
                this.typeView = "table";
            } else if (value === "list") {
                this.typeView = "list";
            }
        },
        // Запросы для остальных фильтров
        checkSelectsDataForRequest() {
            this.check = false;
            // Получаю массив из обязательных полей из структуры
            const listRequired = this.listSelects.filter((obj) => obj.required);
            // Получаю массив из имеющихся заполненных обязательных селектов
            const numberQueryRequired = Object.keys(
                this.$route.query
            ).filter((key) =>
                this.listSelects.some(
                    (obj) => obj.nameI18nAndQueryParam === key && obj.required
                )
            );
            // Сравниваю, что все обязательные селекты заполнены и делаю запрос
            if (numberQueryRequired.length === listRequired.length) {
                this.getSchedule();
            }
        },
    },
};
</script>
<style lang="scss">
@media only screen and (max-width: 800px) {
    #schedule{
        .arrow_btn{
            min-height: 38px;
        }
    }
}
</style>
<style scoped lang="scss">
#schedule::v-deep {
    .vs-sidebar--items {
        overflow-y: auto !important;
        align-items: stretch;
        display: flex;
    }
}

.custom-select-filters::v-deep {
    .multiselect--active {
        z-index: 999 !important;
    }
}
</style>

